import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/app/components/Base/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Misc/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromoBar"] */ "/app/components/PromoBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
